import { render, staticRenderFns } from "./planned_drivers_weekly_dispatch_tbn.vue?vue&type=template&id=0236a1d9&scoped=true&"
import script from "./planned_drivers_weekly_dispatch_tbn.vue?vue&type=script&lang=js&"
export * from "./planned_drivers_weekly_dispatch_tbn.vue?vue&type=script&lang=js&"
import style0 from "./planned_drivers_weekly_dispatch_tbn.vue?vue&type=style&index=0&id=0236a1d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0236a1d9",
  null
  
)

export default component.exports